import { render, staticRenderFns } from "./VerifyInfoText.vue?vue&type=template&id=9d0711b6"
import script from "./VerifyInfoText.vue?vue&type=script&lang=js"
export * from "./VerifyInfoText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports